import { render, staticRenderFns } from "./VuesticOrderModal.vue?vue&type=template&id=69787110"
import script from "./VuesticOrderModal.vue?vue&type=script&lang=js"
export * from "./VuesticOrderModal.vue?vue&type=script&lang=js"
import style0 from "./VuesticOrderModal.vue?vue&type=style&index=0&id=69787110&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69787110')) {
      api.createRecord('69787110', component.options)
    } else {
      api.reload('69787110', component.options)
    }
    module.hot.accept("./VuesticOrderModal.vue?vue&type=template&id=69787110", function () {
      api.rerender('69787110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-modal/VuesticOrderModal.vue"
export default component.exports